import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Overlay from '../../Miscelania/Overlay';

import DatePicker from 'react-datepicker';
import Toggle from 'react-toggle';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';
import getLocale from '../../../i18n/getLocale';

class StaffFlightEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      aircraft_models_list: [],
      fb: '',
      company: 1,
      total_str: '',
      staff_id: '',
      ifr_str: '',
      noturno_str: '',
      h_nav_str: '',
      date: '',
      app: '',
      daytime: '',
      nighttime: '',
      freight_ex: 0,
      observations: '',
      aircraft_model_id: '',
      id: '',
      fb_list: [
        {value: "DC", label: "DC"},
        {value: "IN", label: "IN"},
        {value: "2P", label: "2P"},
        {value: "1P", label: "1P"},
        {value: "CM", label: "CM"},
        {value: "PS", label: "PS"},
      ],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);

    this.editStaffFlight = this.editStaffFlight.bind(this);
    this.modalPropsOff = this.modalPropsOff.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChangeDatePicker (state, date) {
    var change = {};
    change[state] = date.format("DD/MM/YYYY");
    this.setState(change);
  }   
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true) {
      this.setState({ modal: true });
      if(typeof newProps.data_staff_flight_edit.id !== 'undefined') {
        this.setState({
          total_str: newProps.data_staff_flight_edit.total_str,
          fb: newProps.data_staff_flight_edit.fb,
          company: newProps.data_staff_flight_edit.company,
          staff_id: newProps.data_staff_flight_edit.staff_id,
          ifr_str: newProps.data_staff_flight_edit.ifr_str,
          noturno_str: newProps.data_staff_flight_edit.noturno_str,
          h_nav_str: newProps.data_staff_flight_edit.h_nav_str,
          date: newProps.data_staff_flight_edit.date_str,
          app: newProps.data_staff_flight_edit.app,
          daytime: newProps.data_staff_flight_edit.daytime,
          nighttime: newProps.data_staff_flight_edit.nighttime,
          freight_ex: newProps.data_staff_flight_edit.freight_ex_int,
          aircraft_model_id: newProps.data_staff_flight_edit.aircraft_model_id,
          observations: newProps.data_staff_flight_edit.observations,
          id: newProps.data_staff_flight_edit.id,
        });
      }
    } else {
      this.setState({ modal: false });
    }
    if(Array.isArray(newProps.aircraft_models_list)) {
      this.setState({aircraft_models_list: newProps.aircraft_models_list});
    }
  }

  modalPropsOff () {
    this.props.modalPropsOff();
  }

  // Fetch salvando a edição
  editStaffFlight(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      total_str: this.state.total_str,
      fb: this.state.fb,
      company: this.state.company,
      ifr_str: this.state.ifr_str,
      noturno_str: this.state.noturno_str,
      h_nav_str: this.state.h_nav_str,
      date: this.state.date,
      app: this.state.app,
      daytime: this.state.daytime,
      staff_id: this.state.staff_id,
      nighttime: this.state.nighttime,
      freight_ex: this.state.freight_ex,
      aircraft_model_id: this.state.aircraft_model_id,
      observations: this.state.observations,
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/hora', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.refreshTable(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">{this.locale.Tripulantes.AdicionarHorasDoTripulante.tituloEditarHorasDeVoo}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.modalPropsOff()}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.editStaffFlight}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.Aeronave}:</label>
                    <Select
                      className="form-field-name"
                      name="aircraft_model_id"
                      value={this.state.aircraft_model_id}
                      searchable={true}
                      placeholder={this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.placeholder.SelecionarAeronave}
                      onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
                      options={this.state.aircraft_models_list}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.FB}:</label>
                    <Select
                      className="form-field-name"
                      name="fb"
                      value={this.state.fb}
                      searchable={true}
                      placeholder={this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.placeholder.SelecionarTipo}
                      onChange={this.handleSelectChange.bind(this, 'fb')}
                      options={this.state.fb_list}
                    />    
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.Total}:</label>
                    <input value={this.state.total_str} name="total_str" className="form-control" onChange={this.handleChange.bind(this, 'total_str')} placeholder="000000:00" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.IFR}:</label>
                    <input value={this.state.ifr_str} name="ifr_str" className="form-control" onChange={this.handleChange.bind(this, 'ifr_str')} placeholder="000000:00" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.Noturno}:</label>
                    <input value={this.state.noturno_str} name="noturno_str" className="form-control" onChange={this.handleChange.bind(this, 'noturno_str')} placeholder="000000:00" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.HNav}:</label>
                    <input value={this.state.h_nav_str} name="h_nav_str" className="form-control" onChange={this.handleChange.bind(this, 'h_nav_str')} placeholder="000000:00" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.Data}:</label>
                    <DatePicker value={this.state.date} onChange={this.handleChangeDatePicker.bind(this, 'date')} className="form-control" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.APP}:</label>
                    <input value={this.state.app} name="app" className="form-control" onChange={this.handleChange.bind(this, 'app')} placeholder="" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.Diurno}:</label>
                    <input value={this.state.daytime} name="daytime" className="form-control" onChange={this.handleChange.bind(this, 'daytime')} placeholder="" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.Noturno}:</label>
                    <input value={this.state.nighttime} name="nighttime" className="form-control" onChange={this.handleChange.bind(this, 'nighttime')} placeholder="" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.Empresa}:</label>
                    <Select
                      className="form-field-name"
                      name="company"
                      value={this.state.company}
                      searchable={true}
                      placeholder={this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.placeholder.SelecionarTipo}
                      onChange={this.handleSelectChange.bind(this, 'company')}
                      options={[
                        {value: "1", label: this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.opcoesEmpresa.Omni},
                        {value: "2", label: this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.opcoesEmpresa.Outros},
                      ]}
                    />    
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.CargaExterna}:</label>
                    <br/>
                    <Toggle
                      defaultChecked={this.state.freight_ex}
                      checked={this.state.freight_ex}
                      aria-label='No label tag'
                      name="freight_ex"
                      onChange={this.handleToggleChange.bind(this, 'freight_ex')} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>{this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.Observacoes}:</label>
                    <textarea style={{ height: 200 }} type="text" name="observations" className="form-control" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
                  </div>
                </div>
              </div>
             <hr/>
              <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Tripulantes.AdicionarHorasDoTripulante.formularioEditarHorasDeVoo.botaoEditarHora}</button>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.modalPropsOff()}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default StaffFlightEditModal;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffFlightEditModal.js